import React from "react";
import { Layout, Menu, Button, Row, Col, Drawer } from "antd";
import {
  // BarChartOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  PlusSquareOutlined,
  RocketOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { ColorsGeneral } from "../../utils/utils";
import Facturacion from "./Facturacion";
import { VentasHoy } from "./VentasToday";
import { useState } from "react";
import { Typography } from "@material-ui/core";
import "firebase/auth";
import { useFirebaseApp } from "reactfire";
import Logo from "../../Assets/img/logo.png";
import { LayoutProducto } from "./LayoutProducto";
import { MassUpload } from "./MassUpload";
import { AgregarVariacion } from "./AgregarVariacion";

const { Header, Sider } = Layout;

export default function RootLayout() {
  const [contentab, setcontentab] = useState(2);
  let fb = useFirebaseApp();
  let History = useHistory();
  const [visibledrawer, setvisibledrawer] = useState(false);

  const HandleChange = (item) => {
    console.log(item.key);
    if (parseInt(item.key) === 4) {
      Logout();
    } else {
      // console.log(item.key);
      setcontentab(parseInt(item.key));
    }
  };

  const Logout = () => {
    fb.auth()
      .signOut()
      .then(() => {
        History.push("/login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  function onClosedrawer() {
    setvisibledrawer(false);
  }

  function onShowdrawer() {
    setvisibledrawer(true);
  }

  const titles = [
    "nothing",
    "Reporte de ventas",
    "Creación de Productos",
    "Reporte Diario",
    "nothing",
    "Cargue masivo",
    "Agregar Variación a Producto Existente",
  ];

  const renderSwitch = () => {
    switch(contentab) {
      case 1:
        return <Facturacion />;
      
      case 2:
        return <LayoutProducto />
      
      case 3:
        return <VentasHoy />

      case 5:
        return <MassUpload />

      case 6:
        return <AgregarVariacion />

      default:
        return 'No se encontró componente'
    }
  }

  return (
    <Layout>
      <Sider
        className="siderLayout"
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          backgroundColor: "white",
        }}
      >
        <div className="logo">
        <img src={Logo} alt="Seze" className="logo-img-dash" style={{ width: '200px', height: 'auto' }} />
        </div>
        <Menu
          onSelect={(item) => HandleChange(item)}
          mode="inline"
          defaultSelectedKeys={["2"]}
          style={{
            color: "#176AA7",
            fontWeight: "bold",
          }}
        >
          {/* <Menu.Item key="1" icon={<PieChartOutlined />}>
            FACTURACION
          </Menu.Item> */}

          <Menu.Item key="2" icon={<RocketOutlined />}>
            CREAR PRODUCTO
          </Menu.Item>
          
          <Menu.Item key="5" icon={<UploadOutlined />}>
            CARGUE MASIVO
          </Menu.Item>

          <Menu.Item key="6" icon={<PlusSquareOutlined />}>
            AGREGAR VARIACIÓN
          </Menu.Item>

          <Menu.Item key="4" icon={<LogoutOutlined />}>
            CERRAR SESIÓN
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout style={{ minHeight: '100vh' }}>
        <Header
          className="site-layout-background"
          style={{ padding: 0, backgroundColor: ColorsGeneral.mentacolor }}
        >
          <Row>
            <Col span={1} offset={2}>
              <Button
                id="buttonMenumobil"
                onClick={() => onShowdrawer()}
                icon={<MenuUnfoldOutlined />}
                type="primary"
                style={{ backgroundColor: "#176AA7 !important" }}
              />
            </Col>

            <Col style={{ marginTop: 5 }} span={16} offset={2}>
              <Typography
                className="title-header-dash"
                style={{
                  fontSize: "clamp(16px, 4vw, 24px)",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                {titles[contentab]}
              </Typography>
            </Col>
          </Row>

          <Drawer
            className="drawerMobil"
            placement="left"
            closable={false}
            onClose={() => onClosedrawer()}
            open={visibledrawer}
          >
            <div className="logo">
              <img src={Logo} alt="Seze" className="logo-img-dash" style={{ width: '200px', height: 'auto' }}  />
            </div>
            <Menu
              onSelect={(item) => HandleChange(item)}
              mode="inline"
              defaultSelectedKeys={["1"]}
              style={{
                color: "#176AA7",
                fontWeight: "bold",
              }}
            >
              <Menu.Item key="2" icon={<RocketOutlined />}>
                CREAR PRODUCTO
              </Menu.Item>

              <Menu.Item key="5" icon={<UploadOutlined />}>
                CARGUE MASIVO
              </Menu.Item>

              <Menu.Item key="6" icon={<PlusSquareOutlined />}>
                AGREGAR VARIACIÓN
              </Menu.Item>

              <Menu.Item key="4" icon={<LogoutOutlined />}>
                CERRAR SESIÓN
              </Menu.Item>
            </Menu>
          </Drawer>
        </Header>

        { renderSwitch() }
      </Layout>
    </Layout>
  );
}
